import { OktaError } from './types'

export const isLoginRequiredError = (err: OktaError) => err.errorCode === 'login_required'
export const isNotFoundError = (err: OktaError) => err.name === 'AuthApiError' && err.errorCode === 'E0000007'
export const isNoTokenError = (err: OktaError) =>
  err.name === 'AuthSdkError' && err.message === 'Unable to parse a token from the url'
